import { IconChevronRight } from '@tabler/icons-react'
import type React from 'react'
import { Typography } from './Typography'
import styles from './ViewLink.module.css'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type ViewLinkProps = {
  /** リンクラベル（デフォルト: 'すべて表示'） */
  label?: string
  /** href を指定すると <a> としてレンダリング */
  href?: string
  target?: '_self' | '_blank'
  onClick?: () => void
  className?: string
}

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
/**
 * Figma "表示系リンク"（ViewLink）。
 * Primary 色のテキスト＋右矢印。href がある場合は <a>、ない場合は <button> としてレンダリング。
 *
 * @example
 * <ViewLink label="すべて表示" href="/spots" />
 * <ViewLink onClick={() => navigate('/spots')} />
 */
export const ViewLink = ({ label = 'すべて表示', href, target = '_self', onClick, className }: ViewLinkProps) => {
  const inner = (
    <>
      <Typography variant="button2" component="span" className={styles.label}>
        {label}
      </Typography>
      <span className={styles.chevron}>
        <IconChevronRight size={10} stroke={2} color="var(--mantine-color-primary-5)" aria-hidden="true" />
      </span>
    </>
  )

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        className={[styles.viewLink, className ?? ''].join(' ').trim()}
        onClick={onClick}
      >
        {inner}
      </a>
    )
  }

  return (
    <button type="button" className={[styles.viewLink, className ?? ''].join(' ').trim()} onClick={onClick}>
      {inner}
    </button>
  )
}
